/* This is the EMIS private primary and secondary school fee components */

<template>
  <v-container>
    <v-row>
      <span v-html="title"></span>
    </v-row>
    
    <v-row no-gutters>     
      <v-col align-self="center">                
          ប្រភពថវិកាសម្រាប់ដំណើរការសាលារៀន(បើមាន)៖         
      </v-col>
      <v-col>        
          <v-checkbox :input-value="data[0].dt[0] === 1"
            @change="data[0].dt[0] = $event ? 1 : 0" label="១.ក្រសួងអប់រំ">
          </v-checkbox>        
      </v-col>
      <v-col>        
          <v-checkbox :input-value="data[0].dt[1] === 1"
            @change="data[0].dt[1] = $event ? 1 : 0"  label="២.សហគមន៍ជាតិ">
          </v-checkbox>        
      </v-col>
      <v-col>        
          <v-checkbox :input-value="data[0].dt[2] === 1"
            @change="data[0].dt[2] = $event ? 1 : 0"  label="៣.សហគមន៍អន្តរជាតិ">
          </v-checkbox>        
      </v-col>
      <v-col>      
          <v-checkbox :input-value="data[0].dt[3] === 1"
            @change="data[0].dt[3] = $event ? 1 : 0"  label="៤.អង្គភាពសាមី">
          </v-checkbox>        
      </v-col>
      <v-col>        
          <v-checkbox :input-value="data[0].dt[4] === 1"
            @change="data[0].dt[4] = $event ? 1 : 0"  label="៥.ផ្សេងៗ">
          </v-checkbox>        
      </v-col>    
    </v-row>    
  </v-container>
</template>

<script>

export default {
  props: ["data", "title"],
  components: {
  },
  data() {
    return {};
  },
};
</script>
